import layoutActions from "actions/layout";
import mapActions from "actions/map";
import modalActions from "actions/modal";
import { connect, viewStateToProps } from "helpers/redux";

const customDispatch = (dispatch) => {
    return {
        clearData: () => dispatch(layoutActions.clearData()),
        modal: (params) => dispatch(modalActions.open(params)),
        switchMap: (params) => dispatch(mapActions.switchMap(params)),
    };
};

const customState = (state) => viewStateToProps(state, "payment-points");

const customConnect = (Component) => connect(customState, customDispatch)(Component);

export { customConnect };
